import { Button, makeStyles } from '@fluentui/react-components';

// Shared quick-view pills (Spec 2 of the unified-list-filters program). A pill is a one-click
// preset that switches the active view. Behaviour is identical across apps; only styling differs —
// this is the Fluent v9 (makeStyles) styling for tax-lifecycle + supervision. The component owns no
// state and no persistence: it takes the resolved view list, the active key, and an onSelect
// callback (the parent writes `view=<key>` into the URL via the shared codec).

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px',
  },
});

export interface QuickView {
  key: string;
  label: string;
}

export interface QuickViewPillsProps {
  views: QuickView[];
  activeKey: string;
  onSelect: (key: string) => void;
}

export function QuickViewPills({ views, activeKey, onSelect }: QuickViewPillsProps) {
  const styles = useStyles();
  if (views.length === 0) return null;

  return (
    <div className={styles.root} role="group" aria-label="Quick views">
      {views.map((view) => {
        const active = view.key === activeKey;
        return (
          <Button
            key={view.key}
            size="small"
            appearance={active ? 'primary' : 'subtle'}
            aria-pressed={active}
            onClick={() => onSelect(view.key)}
          >
            {view.label}
          </Button>
        );
      })}
    </div>
  );
}

export default QuickViewPills;
